module.exports = __webpack_public_path__ + "static/img/02003C_2_3_R_20190808_fit.ec18c3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/02003C_2_3_R_20190808_fit.png
// module id = nPmm
// module chunks = 0